<div class="container">
  <div class="row">
    <div class="col-11">
      <h1 class="page-title">{{ "CREATE_ACCOUNT_TITLE" | globalTranslate }}</h1>
    </div>
  </div>
  <div class="ps-1 pb-1 hover-red">
    <div class="col text-start">
      <div tabindex="0" class="btn btn-link hover-red" (click)="onPrevious()">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16.875"
          height="15.75"
          viewBox="0 0 16.875 15.75"
        >
          <g
            id="_icons_arrow-back-outline"
            data-name="⚛️ icons/arrow-back-outline"
            transform="translate(0)"
          >
            <path
              id="Combined_Shape"
              data-name="Combined Shape"
              d="M7.093,15.434l-.014-.014L.329,8.671A1.126,1.126,0,0,1,.316,7.093l.014-.014L7.079.329a1.125,1.125,0,0,1,1.6,1.578l-.014.013L3.841,6.75H15.75A1.125,1.125,0,0,1,15.769,9H3.841l4.829,4.829a1.126,1.126,0,0,1,.014,1.578l-.014.013a1.126,1.126,0,0,1-1.578.014Z"
              transform="translate(0)"
              fill="#174a7c"
            />
          </g>
        </svg>
        <span class="ps-2">{{
          "BACK_TO_PREVIOUS_PAGE" | globalTranslate
        }}</span>
      </div>
    </div>
  </div>
  <div class="card p-2">
    <div class="card-body">
      <div class="row">
        <div class="col-11">
          <h2 class="section-header">
            {{ "CREATE_ACCOUNT_SECTION_HEADER" | globalTranslate }}
          </h2>
          <hr />
          <p>
            {{ "CREATE_ACCOUNT_LABEL" | globalTranslate
            }}<strong>{{ "CREATE_ACCOUNT_SIGNIN" | globalTranslate }}</strong
            >.
          </p>
        </div>
      </div>
      <br />
      <div id="accordion">
        @for (item of data ; track item; let i = $index) {
        <div class="row" (click)="item.show = !item.show">
          <div class="col-11">
            <div class="section-header">
              <div
                aria-hidden="true"
                data-bs-toggle="collapse"
                [attr.data-bs-target]="'#collapse' + i"
                aria-expanded="true"
                [attr.aria-controls]="'collapse' + i"
              >
                <div class="d-flex justify-content-between align-items-center">
                  <div>{{ item.key | globalTranslate }}</div>
                  @if (item.show) {
                  <div class="ms-3 item-key-symbol">
                    <i class="fa fa-angle-up"></i>
                  </div>
                  } @if (!item.show) {
                  <div class="ms-3 item-key-symbol">
                    <i class="fa fa-angle-down"></i>
                  </div>
                  }
                </div>
              </div>
            </div>
            <hr />
            <div
              id="collapse{{ i }}"
              [ngClass]="{ show: item.show }"
              class="collapse"
              aria-labelledby="headingOne"
              data-bs-parent="#accordion"
              onClick="event.stopPropagation();"
            >
              <div [innerHtml]="item.value | globalTranslate"></div>
            </div>
          </div>
        </div>
        }
      </div>

      <br />
      <div class="row">
        <div class="col-11">
          <h2>
            <strong>{{ "CREATE_ACCOUNT_TITLE" | globalTranslate }}</strong>
          </h2>
          <p>
            {{ "CREATE_ACCOUNT_LABEL_MSG" | globalTranslate
            }}<strong>{{ "CREATE_ACC_LABEL" | globalTranslate }}</strong
            >.{{ "CREATE_ACCOUNT_LABEL_MSG_1" | globalTranslate }}
          </p>
          <p>{{ "CREATE_ACCOUNT_LABEL_MSG_2" | globalTranslate }}</p>
          <p>
            {{ "CREATE_ACCOUNT_LABEL_MSG_3" | globalTranslate
            }}<strong>{{ "CREATE_ACC_LABEL" | globalTranslate }}</strong
            >{{ "CREATE_ACCOUNT_LABEL_MSG_3_1" | globalTranslate }}
          </p>
        </div>
      </div>
    </div>
  </div>
  <br />
  <div class="row mb-2 pb-3">
    <div class="col text-end">
      <button
        [routerLink]="['/register-account']"
        class="btn col-md-3 btn-secondary d-grid"
      >
        {{ "CREATE_ACC" | globalTranslate }}
      </button>
    </div>
  </div>
</div>